<div class="d-flex flex-column gap-3">
    <div class="alert alert-info m-0">
        You can choose one of the following options while scheduling a meeting:
        <ul class="mb-0">
            <li>Click <b>Let me create my own agenda</b> to continue with an empty agenda, which you can fill out in the next step.</li>
            <li>
                Or choose from a team or organisation template below.
                <ul>
                    <li>
                        If you want to get started straight away, you can click
                        <b>Run meeting now</b> after selecting a template.
                    </li>
                    <li>
                        Or you can customise the agenda as needed by clicking
                        <b>Customise Agenda</b>
                    </li>
                </ul>
            </li>
        </ul>
    </div>

    <div class="d-flex flex-row flex-wrap gap-2">
        <button class="btn btn-primary"
                adaptButtonIcon="edit"
                (click)="createOwnAgenda()"
                data-test="create-own-agenda-button">Let me create my own agenda</button>

        <button class="ms-auto"
                adaptButton="downloadLink"
                (click)="importRecentMeeting()"
                data-test="import-recent-meeting">Import recent meeting</button>
    </div>

    <hr class="m-0" />

    @if (isInitialised) {
        <adapt-template-selector [currentTeam]="runData.meeting.team"
                                 [selectedTemplateId]="runData.selectedTemplateId"
                                 [newAgendaTemplate]="newAgendaTemplate"
                                 (selectedAgendaTemplateChange)="onAgendaSelected($event)"></adapt-template-selector>
    }
    @if (selectedAgendaTemplate && !agendaHasItems) {
        <div class="alert alert-warning m-0">The selected meeting agenda has no agenda items. Please select a different agenda.</div>
    }
</div>

<ng-template #createAgendaButton>
    <button *adaptIfAuthorised="ConfigureTeam; entity: runData.meeting.team"
            type="button"
            class="p-1"
            adaptButton="addLink"
            data-test="create-agenda-button"
            [disabled]="submitting"
            [adaptBlockingClick]="createNewAgenda">Create new template</button>
</ng-template>

<ng-template #startMeetingNowButton>
    <div [adaptTooltip]="startMeetingNowTooltip"
         [class.d-none]="!showRunMeetingNowButton">
        <button type="button"
                class="btn btn-secondary"
                adaptButtonIcon="runMeetingNow"
                data-test="run-meeting-now-button"
                [disabled]="!isValid.value || !!nonStartableMeetingInfo || !selectedAgendaTemplate || submitting"
                [adaptBlockingClick]="populateAndRunMeetingNow"
                [unsubscribeOnDestroy]="false"
                [enableButtonOnFinalize]="false">
            {{ runMeetingNowButtonText }}
        </button>
    </div>
</ng-template>
